import React, { useState, useRef } from 'react';
import './Map.css';
import { useEffect } from 'react';
import { Mapcontainer } from './Mapcontainer';
import axios from 'axios';
import { createChatSocket } from "../../utils/chatSocket";
import markerSiteIcon from '../../icon/marker-site.svg';
import markerRdvIcon from '../../icon/marker-rdv.svg';
import carPumpIcon from '../../icon/fire_pump_truck_marker_64px.png';
import carOffroadIcon from '../../icon/fire_offroad_pump_truck_marker_64px.png';
import carTankIcon from '../../icon/fire_water_tanker_marker_64px.png';
import carChemicalIcon from '../../icon/fire_chemical_truck_marker_64px.png';
import carRescueIcon from '../../icon/fire_rescue_truck_marker_64px.png';
import carAmbulanceIcon from '../../icon/fire_ambulance_marker_64px.png';
import carHelicopterIcon from '../../icon/fire_helicopter_marker_64px.png';
import carCommandIcon from '../../icon/fire_command_van_marker_64px.png';
import carRecoveryIcon from '../../icon/fire_recovery_truck_marker_64px.png';
import carAdminIcon from '../../icon/fire_admin_car_marker_64px.png';
import carSatelliteIcon from '../../icon/fire_satellite_van_marker_64px.png';
import carPoliceIcon from '../../icon/police_car_marker_64px.png';
import carGovernmentIcon from '../../icon/government_car_marker_64px.png';
import carVolunteerIcon from '../../icon/volunteer_fire_truck_marker_64px.png';
import carCivilianIcon from '../../icon/civilian_car_marker_64px.png';
let map;
let marker

const beforeOverlays = []; // 기존마커삭제를 위한 배열 선언
const nowOverlays = []; // 현재마커를 저장하기 위한 배열 선언
const markerArr = []; // 마커를 담을 배열 선언
const markerWithTitleArr = []; // 타이틀+아이콘 한 묶음 오버레이 (배율과 무관하게 타이틀 상단 고정)
const beforePhotoOverlays = []; // 기존사진마커삭제를 위한 배열 선언
const nowPhotoOverlays = []; // 현재사진마커를 저장하기 위한 배열 선언

///////////// socket.io //////////////
const socket = createChatSocket();
///////////// socket.io //////////////


function KakaoMap(props) {  
  const [getloc, setGetloc] = useState(false);
  const startRef = useRef(0); // 현재 재난키 저장용 ref (재난키가 변경되면 맵을 새로 그림)
  const skipCenterRef = useRef(false); // 갱신 버튼 클릭 시 중심 이동 스킵
  const [maptype, setMaptype] = useState(false); // 지도종류 (roadmap, hybrid) 
  
  ///////////// socket.io //////////////
  useEffect(() => {
    socket.on("syncphoto", (data) => {  // 소켓서버에서 보낸 자료를 받음(사진목록 갱신요청)
      const { dsid } = data;
      if(dsid == sessionStorage.ondsid.trim()){
        setGetloc(Math.random());
      }
    });
  }, []);



  //스크립트 파일 읽어오기
  // alert("갱신요청 프롭은 ? : " + props.LocRefrsh)
  const new_script = (src) => { 
    return new Promise((resolve, reject) => { 
      const script = document.createElement('script'); 
      script.src = src; 
      script.addEventListener('load', () => { 
        resolve(); 
      }); 
      script.addEventListener('error', e => { 
        reject(e); 
      }); 
      document.head.appendChild(script); 
    }); 
  };

  const refreshLocation = () => { 
    skipCenterRef.current = true; // 갱신 시 현재 지도 위치 유지
    setGetloc(Math.random());
  }
  
  useEffect(() => {
    // startRef.current = sessionStorage.ondsid;
    // alert("startRef : " + startRef.current)
    //카카오맵 스크립트 읽어오기
    const my_script = new_script('https://dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=b7967dc1f2c2b6f788a029bc7b701f09&libraries=services,clusterer,drawing');

    my_script.then(() => {
      const kakao = window['kakao'];
      if (!kakao || !kakao.maps || typeof kakao.maps.load !== 'function') {
        console.error('Kakao Maps SDK not ready');
        return;
      } 
      let lat, lon;
      const ismap = !(!map) // 지도 유무 확인
      kakao.maps.load(() => {
        const kakaoMaps = window.kakao && window.kakao.maps ? window.kakao.maps : kakao.maps;
        if (typeof kakaoMaps.LatLng !== 'function') {
          console.error('Kakao Maps LatLng not ready');
          return;
        }

        // 타이틀+아이콘 한 묶음 오버레이 (yAnchor:1로 핀 끝이 좌표에 고정). iconSize 생략 시 32x42 (재난/집결지용)
        const addMarkerWithTitle = (position, title, iconUrl, iconSize) => {
          if (!map) return;
          const container = document.createElement('div');
          container.style.cssText = 'display:flex;flex-direction:column-reverse;align-items:center;pointer-events:none;';
          const titleDiv = document.createElement('div');
          titleDiv.style.cssText = 'padding:2px 6px;background:rgba(255,255,255,0.95);border:1px solid #ccc;border-radius:4px;font-size:11px;font-weight:bold;white-space:nowrap;box-shadow:0 1px 2px rgba(0,0,0,0.2);margin-bottom:2px;';
          titleDiv.textContent = title || '';
          const img = document.createElement('img');
          img.src = iconUrl;
          const w = (iconSize && iconSize.width) != null ? iconSize.width : 32;
          const h = (iconSize && iconSize.height) != null ? iconSize.height : 42;
          img.style.cssText = `width:${w}px;height:${h}px;display:block;`;
          img.alt = '';
          container.appendChild(img);
          container.appendChild(titleDiv);
          const overlay = new kakaoMaps.CustomOverlay({
            position: position,
            content: container,
            yAnchor: 1,
          });
          overlay.setMap(map);
          markerWithTitleArr.push(overlay);
        };

        // 동원자원 마커: 아이콘만 표시, 마우스 오버 시 소속-장비명 툴팁 (아이콘 상단 가운데)
        const addCarMarker = (position, iconUrl, iconSize, orgName, eqpName) => {
          if (!map) return;
          const container = document.createElement('div');
          container.style.cssText = 'display:flex;flex-direction:column;align-items:center;cursor:pointer;position:relative;';
          const tooltipDiv = document.createElement('div');
          const o = (typeof orgName === 'string' ? orgName : '').trim();
          const e = (typeof eqpName === 'string' ? eqpName : '').trim();
          tooltipDiv.textContent = [o, e].filter(Boolean).join('-') || '';
          tooltipDiv.style.cssText = 'padding:2px 6px;background:rgba(255,255,255,0.95);border:1px solid #ccc;border-radius:4px;font-size:11px;font-weight:bold;white-space:nowrap;box-shadow:0 1px 2px rgba(0,0,0,0.2);margin-bottom:2px;display:none;';
          const img = document.createElement('img');
          img.src = iconUrl;
          const w = (iconSize && iconSize.width) != null ? iconSize.width : 32;
          const h = (iconSize && iconSize.height) != null ? iconSize.height : 42;
          img.style.cssText = `width:${w}px;height:${h}px;display:block;`;
          img.alt = '';
          container.appendChild(tooltipDiv);
          container.appendChild(img);
          container.addEventListener('mouseenter', () => { tooltipDiv.style.display = tooltipDiv.textContent ? 'block' : 'none'; });
          container.addEventListener('mouseleave', () => { tooltipDiv.style.display = 'none'; });
          const overlay = new kakaoMaps.CustomOverlay({
            position: position,
            content: container,
            yAnchor: 1,
          });
          overlay.setMap(map);
          markerWithTitleArr.push(overlay);
        };

        // 최초 재난위치 가져오기 맵 생성 재난선택시 1번만 실행 (다중 현장 지원)
        const getDSlocation = () => {
          sessionStorage.firstSelDs = sessionStorage.ondsid;
          let sites = [];
          try {
            const dsSitesStr = sessionStorage.dsSites;
            if (dsSitesStr) sites = JSON.parse(dsSitesStr);
          } catch (e) {}
          if (!Array.isArray(sites)) sites = [];

          if (sites.length > 0) {
            lat = sessionStorage.ondslat || sites[0].slat;
            lon = sessionStorage.ondslon || sites[0].slon;
          } else {
            lat = sessionStorage.ondslat;
            lon = sessionStorage.ondslon;
          }
          const mapContainer = document.getElementById('map');
          const options = { 
            center: new kakaoMaps.LatLng(lat, lon),
            level: 5 
          }; 

          if(startRef.current < 3) {
            map = new kakaoMaps.Map(mapContainer, options);
          }

          if(markerArr.length > 0){
            for (const m of markerArr) {
              m.setMap(null);
            }
            markerArr.length = 0;
          }
          if (markerWithTitleArr.length > 0) {
            for (const o of markerWithTitleArr) {
              o.setMap(null);
            }
            markerWithTitleArr.length = 0;
          }

          const onsiteid = (sessionStorage.onsiteid || "").toString();

          if (sites.length > 0) {
            let centerPos = null;
            sites.forEach((site) => {
              const slat = site.slat && parseFloat(site.slat);
              const slon = site.slon && parseFloat(site.slon);
              if (isNaN(slat) || isNaN(slon)) return;
              const markerPosition = new kakaoMaps.LatLng(slat, slon);
              const isSelected = (site.snum != null && String(site.snum) === onsiteid) || (!centerPos && !onsiteid);
              if (isSelected) centerPos = markerPosition;
              addMarkerWithTitle(markerPosition, site.sname || '현장', markerSiteIcon);
            });
            // 자원집결지 선택 시 해당 위치로 지도 중심 이동 (갱신 버튼에서는 스킵)
            if (!skipCenterRef.current) {
              if (sessionStorage.centerOnRdv === '1' && lat && lon) {
                const rdvPosition = new kakaoMaps.LatLng(lat, lon);
                addMarkerWithTitle(rdvPosition, sessionStorage.centerOnRdvTitle || '집결지', markerRdvIcon);
                map.setCenter(rdvPosition);
                delete sessionStorage.centerOnRdv;
                delete sessionStorage.centerOnRdvTitle;
              } else {
                if (centerPos) map.setCenter(centerPos);
                else map.setCenter(new kakaoMaps.LatLng(lat, lon));
              }
            }
            skipCenterRef.current = false;
          } else {
            const markerPosition = new kakaoMaps.LatLng(lat, lon);
            addMarkerWithTitle(markerPosition, '재난', markerSiteIcon);
            if (!skipCenterRef.current) map.setCenter(markerPosition);
            skipCenterRef.current = false;
          }

          // 해당 재난에 연결된 자원집결지 마커 표시
          const getRdvLocations = async () => {
            const dsid = sessionStorage.ondsid;
            if (!dsid || !props.apiAddr || !map) return;
            try {
              const res = await axios.get(`${props.apiAddr}/get/getdsrdvs?dsid=${encodeURIComponent(dsid)}`);
              const list = Array.isArray(res.data) ? res.data : [];
              list.forEach((row) => {
                const rlat = parseFloat(row.lat);
                const rlon = parseFloat(row.lon);
                if (isNaN(rlat) || isNaN(rlon)) return;
                const markerPosition = new kakaoMaps.LatLng(rlat, rlon);
                addMarkerWithTitle(markerPosition, row.rname || '집결지', markerRdvIcon);
              });
            } catch (e) {
              console.warn('getdsrdvs failed', e);
            }
          };
          getRdvLocations().then(() => getCarLocation());
        }

        // 전체 차량위치 가져오기
        const getCarLocation = async () => {
          const dsid = sessionStorage.ondsid;
          const wstring = `${props.apiAddr}/get/getcarcoor?dsid=${dsid}`;
          console.log(wstring);
          const responsedata = await axios.get(wstring);
          const carlocation = responsedata.data;
          // console.log(carlocation)

          carlocation.map((car) => {
            const markerPosition = new kakaoMaps.LatLng(car.mflat, car.mflon);
            const eqp = car.mfeqp.trim();
            const isPump = eqp === '소방펌프';
            const isOffroad = eqp === '소방험지' || eqp.includes('험지');
            const isTank = eqp === '소방물탱크';
            const isRescue = eqp === '소방구조' || eqp.includes('구조');
            const isAmbulance = eqp === '소방구급' || eqp.includes('구급');
            const isHelicopter = eqp === '소방헬기' || eqp.includes('헬기');
            const isCommand = eqp === '소방지휘' || eqp.includes('지휘');
            const isRecovery = eqp === '소방회복' || eqp.includes('회복');
            const isAdmin = eqp === '소방행정' || eqp.includes('행정');
            const isSatellite = eqp.includes('위성');
            const isPolice = eqp.includes('경찰');
            const isGovernment = eqp.includes('공무원');
            const isVolunteer = eqp.includes('의소대');
            const isChemical = eqp === '소방화학' || eqp.includes('화학');
            let carIcon = null;
            if (isPump) carIcon = carPumpIcon;
            else if (isOffroad) carIcon = carOffroadIcon;
            else if (isTank) carIcon = carTankIcon;
            else if (isChemical) carIcon = carChemicalIcon;
            else if (isRescue) carIcon = carRescueIcon;
            else if (isAmbulance) carIcon = carAmbulanceIcon;
            else if (isHelicopter) carIcon = carHelicopterIcon;
            else if (isCommand) carIcon = carCommandIcon;
            else if (isRecovery) carIcon = carRecoveryIcon;
            else if (isAdmin) carIcon = carAdminIcon;
            else if (isSatellite) carIcon = carSatelliteIcon;
            else if (isPolice) carIcon = carPoliceIcon;
            else if (isGovernment) carIcon = carGovernmentIcon;
            else if (isVolunteer) carIcon = carVolunteerIcon;
            else carIcon = carCivilianIcon; // 기타차량 → civilian_car_marker_64px
            const iconSize = { width: 32, height: 32 };
            addCarMarker(markerPosition, carIcon, iconSize, car.mfdorg || '', car.mfcsgn || '');
          })

          

          if(startRef.current > 2) {
            for (const overlay of beforeOverlays) {
              overlay.setMap(null);
              console.log(overlay.position)
            }
          }

          // beforeOverlays 에 nowOverlays 를 복사
          beforeOverlays.length = 0;
          beforeOverlays.push(...nowOverlays);
          // nowOverlays 초기화
          nowOverlays.length = 0;

          // console.log(beforeOverlays)
          // console.log(nowOverlays)
          // console.log(startRef.current )
        }

        const getPhotoList = async () => {
          const dsid = sessionStorage.ondsid;
          const wstring = `${props.apiAddr}/get/getphotolist?dsid=${dsid}`;
          console.log(wstring);
          const responsedata = await axios.get(wstring);
          const photolist = responsedata.data;
          // console.log(photolist)

          photolist.map((photo) => {
            const fn = photo.cfilename;
            if (!fn || String(fn).trim() === '' || String(fn) === 'undefined') return;
            const markerPosition = new kakaoMaps.LatLng(photo.clat, photo.clon);
            const filepath = `https://mfm.119survey.org/uploads/${fn}`;

            const spn = document.createElement('span');
            spn.classList.add('photo');
            const img = document.createElement('img');
            img.src = filepath;            
            img.title = photo.cname;
            const imgcontainer = document.createElement('div'); // 사진크게보기 컨테이너는 처음에 숨김으로 있다가 사진을 클릭하면 하단에 보이게 함
            imgcontainer.classList.add('imgcontainer');
            imgcontainer.style.display = 'none';
            img.addEventListener('click', () => { // 사진 클릭시   imgcontainer 보이기 토글
              if(imgcontainer.style.display == 'none'){
                imgcontainer.style.display = 'block'
                const zoomimg = document.createElement('img');
                zoomimg.addEventListener('click', () => { // 사진 클릭시  imgcontainer 숨기기 
                  imgcontainer.style.display = 'none'
                  imgcontainer.innerHTML = '';
                });
                zoomimg.src = filepath;
                console.log(filepath)
                // zoomimg를 가로세로중 큰값을 100% 설정하되 300px보다 크면 300px로 설정
                if(img.width > img.height){
                  if(img.width > 300){
                    zoomimg.style.width = '300px';
                    zoomimg.style.height = 'auto';
                  }else{
                    zoomimg.style.width = 'auto';
                    zoomimg.style.height = '100%';
                  }
                }else{
                  if(img.height > 300){
                    zoomimg.style.width = 'auto';
                    zoomimg.style.height = '300px';
                  }else{
                    zoomimg.style.width = '100%';
                    zoomimg.style.height = 'auto';
                  }
                }
                imgcontainer.appendChild(zoomimg);
              }else{
                imgcontainer.style.display = 'none'
                imgcontainer.innerHTML = '';
              }
            });
            spn.appendChild(img);
            spn.appendChild(imgcontainer);
            var content = spn
          
            var customPhotoOverlay = new kakaoMaps.CustomOverlay({
              position: markerPosition,
              content: content,
              yAnchor: -0.5,
            });

            nowPhotoOverlays.push(customPhotoOverlay); // 현재마커를 배열에 저장
            customPhotoOverlay.setMap(map); // 지도에 마커를 표시합니다
          })

          if(startRef.current > 2) { 
            for (const overlay of beforePhotoOverlays) { // 기존마커 삭제
              overlay.setMap(null);
            }
          }

          // beforeOverlays 에 nowOverlays 를 복사
          beforePhotoOverlays.length = 0;  // 기존마커 삭제
          beforePhotoOverlays.push(...nowPhotoOverlays); // 현재마커를 기존마커에 저장
          nowPhotoOverlays.length = 0; // 현재마커 초기화

          // console.log(beforePhotoOverlays)
          // console.log(nowPhotoOverlays)
          // console.log(startRef.current )
        }
        getPhotoList()
        
        //마커추가
        // const markerPosition1 = new kakao.maps.LatLng(38.371602, 128.506218);
        // const marker1 = new kakao.maps.Marker({ 
        //   position: markerPosition1
        // });
        // marker1.setMap(map);

        // const marker = new kakao.maps.Marker({ 
        //   title: car.mfcsgn,
        //   // content:`<div className=${redmarker}></div>`,
        //   image: new kakao.maps.MarkerImage(null, new kakao.maps.Size(30, 30)),
        //   position: markerPosition
        // });
        //마커를 맵에 추가

        // alert(startRef.current)
        if(startRef.current === 2) { // 최초 맵실행이면 무조건 맵 생성(맵생성 여부 확인을 건너뜀)
          getDSlocation()
        }else{
          if(sessionStorage.ondsid != undefined){
            getDSlocation() // 재난/현장 선택 시 지도 중심을 해당 위치로 이동
          }else{
            if(sessionStorage.ondsid == sessionStorage.firstSelDs){
              if(sessionStorage.ondsid != undefined) getCarLocation()
            }else{
              getDSlocation()
            }
            if(ismap) getCarLocation()
          }
        }

        if(startRef.current > 2) { // 최초 맵실행이면 무조건 맵 생성(맵생성 여부 확인을 건너뜀)
          if(maptype){
            map.setMapTypeId(kakaoMaps.MapTypeId.HYBRID);
          }else{
            map.setMapTypeId(kakaoMaps.MapTypeId.ROADMAP); 
          }
        }

      });   
    }); 
    ++startRef.current;
  }, [props.mapfresh, getloc]);

  const changeMatype = (type) => {
    if (type === "roadmap") setMaptype(false);
    if (type === "hybrid") setMaptype(true);
    // 지도/위성 전환 시 현재 위치 유지, 맵 타입만 변경
    if (map && window.kakao) {
      map.setMapTypeId(window.kakao.maps.MapTypeId[type === "roadmap" ? "ROADMAP" : "HYBRID"]);
    }
  }

  return (
    <div className="App">
      <Mapcontainer refreshloc={refreshLocation} maptype={changeMatype} viewmaptool={props.viewmaptool} />
    </div>
  );
}

export default KakaoMap;